var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"abody"},[(_vm.loading)?_c('van-loading',{attrs:{"size":"60px"}},[_vm._v("下载中...")]):_c('van-button',{attrs:{"type":"primary"},on:{"click":_vm.downFileBtn}},[_vm._v("点击下载")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }